import React from 'react'
import Videos from '../../components/Videos'

const TipsVideos = ({ pageContext: { videos } }) => (
  <Videos className="section" videos={videos} />
)

export default TipsVideos
